import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { HrrList } from "../../definitions/api/hrr/hrr-list";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class HrrService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/hrr", appConfigService.getConfigValue("API_ENDPOINT") as string);
	}

	fetchHrrList(): Observable<HrrList> {
		return this.api.getAndThrowError<HrrList>(this.url());
	}
}
